import React from 'react';
import MUIDataTable from 'mui-datatables';
import PapperBlock from '../../../../components/PapperBlock/PapperBlock';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import styles from './../reportes-jss'
import { LanguageConsumer, LanguageCxt } from './../../../../language/LanguageContext';

//Filtros
import { renderInput, getSuggestions, renderSuggestion } from './../autocomplete'
import Downshift from 'downshift';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import { apiPOST, returnCurrentUserId, returnCurrentUser } from '../../../../services/service_base';
import Loader from '../../../../components/Loader/Loader';
import Grid from '@material-ui/core/Grid';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

import { textLabelsEs } from '../../../../utils/tableTexts';

import IconButton from '@material-ui/core/IconButton';
import CloudDownload from '@material-ui/icons/CloudDownload';

import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import moment from 'moment';

class Prospectos extends React.Component {
  state = {
    //Filters
    productor: 0,
    tituloObra: '',
    specificDate: null,
    //Table
    columns: [],
    data: [],
    //Catalogos
    producers: [],
    works: [],
    results: 0,
    isLoading: true,
    page: 0,
    rowsPerPage: 10,
    request: {},
    body: {
      id_usuario: returnCurrentUserId(),
      user_action: 3,
      work_id: 0,
      portal: 'acervo',
      screen: 'reporteProspectos'
    },
  }

  

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleStateChange = changes => {
    if (changes.hasOwnProperty('selectedItem')) {
      this.setState({ tituloObra: changes.selectedItem })
    } else if (changes.hasOwnProperty('inputValue')) {
      this.setState({ tituloObra: changes.inputValue })
    }
  }

  handleClearFilters = () => {
    this.setState({
      productor: 0,
      tituloObra: '',
      specificDate: null,
      isLoading: true
    });

    const request = {
      idProducer: 0,
      title: "0",
      specificDate: null
    }
    this.handleFetch(request);
  }

  searchs = () => {
    this.setState({ isLoading: true })
    const request = {
      idProducer: this.state.productor,
      title: this.state.tituloObra === "" ? "0" : this.state.tituloObra === "TODOS" ? "0" : this.state.tituloObra,
      specificDate: this.state.specificDate,
    }

    this.handleFetch(request);
  }

  componentDidMount() {

    const { lang } = this.context;
    this.setState({
      columns: [
        lang.reports.title, lang.reports.producer, lang.reports.assigmentDate,
        lang.reports.englishTitle, lang.reports.otherTitle, lang.reports.comments
      ]
    })

    //Catalogo productores
    //AHDA 16/05/2019: Added valdation for refreshing
    apiPOST('/catalogue/get', { idCatalogo: 17 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ producers: response.data })
        }
        else {
          this.setState({ openError: true });
        }
      }).catch(
        error => {
          this.setState({ openError: true, isLoading: false });
        });

    //Catalogo obras
    //AHDA 16/05/2019: Added valdation for refreshing
    apiPOST('/catalogue/get', { idCatalogo: 16 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ works: response.data })
        } else {
          this.setState({ openError: true });
        }
      }).catch(
        error => {
          this.setState({ openError: true, isLoading: false });
        });


    const { page, rowsPerPage } = this.state;
    const offset = page * rowsPerPage;
    //Carga inicial
    const request = {
      idProducer: 0,
      title: "0",
      specificDate: null,
      limit: rowsPerPage,
      offset: offset
    }
    this.setState({ request: request })
    this.handleFetch(request);
  }

  handleFetch = (request) => {
    apiPOST('/reports/getByProspects', request).then(response => {
      if (response.status === 200) {
        const result = [];
        for (const x in response.data) {
          const obj = [];
          const auxObj = response.data[x]; 
          obj.push(auxObj.title ? auxObj.title : "-");
          obj.push(auxObj.user ? auxObj.user : "-");
          obj.push(auxObj.assigment_date ? auxObj.assigment_date : "-");
          obj.push(auxObj.english_title ? auxObj.english_title : "-");
          obj.push(auxObj.other_title ? auxObj.other_title : "-");
          obj.push(auxObj.comments || "-");
          result.push(obj);
        }
        this.setState({ data: result, isLoading: false, results: response.data.length, totalCount: response.total_count })
      } else {
        this.setState({ openError: true, isLoading: false });
      }
    }).catch(error => {
      this.setState({ openError: true, isLoading: false });
    });
  }

  render() {
    const { classes } = this.props;
    const { columns, data } = this.state;
    //AHDA 29/04/2019
    //Changed filterType
    const options = {
      filterType: 'multiselect',
      responsive: 'scroll',
      download: true,
      print: false,
      rowsPerPage: this.state.rowsPerPage,
      page: this.state.page,
      count: this.state.totalCount,
      serverSide: true,
      selectableRows: false,
      textLabels: textLabelsEs,
      downloadOptions: {
        filename: `Reporte_Prospectos_${moment().format('YYYYMMDD_HHmm')}.csv`,
        filterOptions: {
          useDisplayedRowsOnly: true,
          useDisplayedColumnsOnly: true
        }
      },
      onDownload: (buildHead, buildBody, columns, data) => {
        apiPOST('/audit/add', this.state.body);
        const currentUser = returnCurrentUser();
        const authorName = currentUser ? `${currentUser.nombre} ${currentUser.apellidos}` : '-';
        const generationDate = moment().format('DD/MM/YYYY HH:mm');
        const reportInfo = `"Autor:","${authorName}"\r\n"Fecha:","${generationDate}"\r\n\r\n`;
        return "\ufeff" + reportInfo + buildHead(columns) + buildBody(data);
      },
      onChangePage: (newPage) => {
        this.setState({ page: newPage, isLoading: true, data: [] }, () => {
          const { rowsPerPage } = this.state;
          this.handleFetch({ ...this.state.request, offset: newPage * rowsPerPage });
        });
      },
      onChangeRowsPerPage: (newRowsPerPage) => {
        this.setState({ rowsPerPage: newRowsPerPage, page: 0, isLoading: true, data: [] }, () => {
          this.handleFetch({ ...this.state.request, limit: newRowsPerPage, offset: 0 });
        });
      },
      customSearch: (searchQuery, currentRow) => {
        let isFound = false;
        const str = searchQuery.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        currentRow.forEach(col => {
          if (col && col.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(str) >= 0) {
            isFound = true;
          }
        });
        return isFound;
      }
    };
    return (
      <div className="marginTopLogo">
        <LanguageConsumer>
          {
            ({ lang }) =>
              <PapperBlock title={lang.reports.reports} whiteBg desc="">
                {/* Inicio Filtros */}
                <form className={classes.container}>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={12} sm={6} md={6}>
                      <FormControl className={classes.formControl}>
                        <Select value={this.state.productor} onChange={this.handleChange} name="productor" displayEmpty className={classes.selectEmpty}>
                          <MenuItem value={0}>{lang.reports.all}</MenuItem>
                          {
                            this.state.producers.map((producer, idx) =>
                              (
                                <MenuItem value={producer.value} key={`producer${idx}`}>{producer.data}</MenuItem>
                              ))
                          }
                        </Select>
                        <FormHelperText>{lang.reports.producer}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className={classes.positionRelative}>
                      <div className={classes.root}>
                        <Downshift selectedItem={this.state.tituloObra} onStateChange={this.handleStateChange}>
                          {({
                            getInputProps,
                            getItemProps,
                            isOpen,
                            inputValue,
                            selectedItem,
                            highlightedIndex
                          }) => (
                              <div className={classes.formControl}>
                                {renderInput({
                                  fullWidth: true,
                                  classes,
                                  // helperText: lang.reports.company,
                                  helperText: lang.reports.title,
                                  InputProps: getInputProps({
                                    // placeholder: lang.reports.company,
                                    placeholder: lang.reports.title,
                                    id: 'titulo',
                                    name: 'titulo',
                                  }),
                                })}
                                {isOpen ? (
                                  <Paper className={classNames(classes.paper, classes.list)} square>
                                    {getSuggestions(inputValue, this.state.works).map((suggestion, index) =>
                                      renderSuggestion({
                                        suggestion,
                                        index,
                                        itemProps: getItemProps({ item: suggestion.label }),
                                        highlightedIndex,
                                        selectedItem,
                                      }),
                                    )}
                                  </Paper>
                                ) : null}
                              </div>
                            )}
                        </Downshift>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className={classes.positionRelative}>
                        <MuiPickersUtilsProvider className={classes.w100} item utils={MomentUtils}>
                            <DatePicker
                                keyboard={false}
                                className={classes.w100}
                                format="DD/MM/YYYY"
                                value={this.state.specificDate}
                                onChange={(date) => this.setState({ specificDate: moment(date).format('YYYY-MM-DD') })}
                                disableOpenOnEnter
                                animateYearScrolling={false}
                                clearable={true}
                                cancelLabel={lang.common.cancel}
                                clearLabel={lang.common.clear}
                                placeholder="DD/MM/AAAA"
                                InputLabelProps={{ shrink: true }}
                            />
                        </MuiPickersUtilsProvider>
                        <FormHelperText className={classes.w100}>{lang.reports.date}</FormHelperText>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={12}>
                      <Button onClick={this.searchs} variant="contained" color="primary" className={classes.button}>
                        {lang.searchs.search}
                      </Button>
                      <Button variant="contained" color="primary" className={classes.button} onClick={this.handleClearFilters}>
                        Limpiar
                  </Button>
                    </Grid>
                  </Grid>
                </form>
                {/* Fin Filtros */}
                <div className={classes.bitacoraMov}>
                  {
                    this.state.isLoading ?
                      <Loader text={"Cargando"} /> :
                      <MUIDataTable title={`${lang.reports.prospects} (${this.state.results} ${lang.reports.results})`} data={data} columns={columns} options={options} />
                  }
                </div>
              </PapperBlock>
          }
        </LanguageConsumer>
      </div>
    );
  }
}

Prospectos.contextType = LanguageCxt;

export default withStyles(styles)(Prospectos);